import { FREE_TOKEN_COUNT } from 'my-core/subscription-utils';

import Label from 'my-elements/Label';

import Tooltip from '@mui/material/Tooltip';

import { faCoinVertical } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function FreeContentLabel({ grouping }) {
  return (
    <Tooltip
      title={
        FREE_TOKEN_COUNT ?
          `Free! ${
            grouping ? `None of the activities within this ${grouping}` : 'Does not'
          } count towards ${FREE_TOKEN_COUNT} free activity limit`
        : null
      }
    >
      <Label
        color="green"
        label={
          <>
            <FontAwesomeIcon icon={faCoinVertical} />
            {' Free'}
          </>
        }
        variant="light"
      />
    </Tooltip>
  );
}
